import { cn } from "../ui/utils";

export interface LogoProps {
  /**
   * Logo variant - white for dark backgrounds, black for light backgrounds
   * @default 'white'
   */
  variant?: 'white' | 'black';
  /**
   * Logo size preset
   * @default 'md'
   */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  /**
   * Optional className for additional styling
   */
  className?: string;
}

const sizeMap = {
  xs: 56,
  sm: 80,
  md: 140,
  lg: 200,
  xl: 280,
} as const;

/**
 * Studio Bereikbaar Logo Component
 *
 * Displays the horizontal Studio Bereikbaar logo with appropriate variant and size.
 *
 * @example
 * ```tsx
 * // Default medium white logo
 * <Logo />
 *
 * // Black logo for light backgrounds
 * <Logo variant="black" />
 *
 * // Large white logo
 * <Logo size="lg" />
 * ```
 */
export function Logo({
  variant = 'white',
  size = 'md',
  className
}: LogoProps) {
  const logoSrc = variant === 'white'
    ? '/assets/branding/logo-white-horizontal.png'
    : '/assets/branding/logo-black-horizontal.png';

  const width = sizeMap[size];

  return (
    <img
      src={logoSrc}
      alt="Studio Bereikbaar"
      width={width}
      className={cn("object-contain", className)}
      style={{ height: 'auto' }}
    />
  );
}
